import { motion } from 'framer-motion';
import Button from '../common/Button';
import backgroundImage from '../../assets/images/pexels-bemistermister-4034475.jpg';
import arrowCircleRight from '../../assets/images/arrow-circle-right.png';

const Hero = () => {
  return (
    <div id="hero" className="min-h-screen flex items-center relative overflow-hidden bg-dark pt-0">
      <div className="absolute inset-0 z-0">
        <motion.div
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.6)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-8 z-10 w-full py-20">
        <div className="max-w-xl">
          <motion.h1
            className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Understanding people through their handwriting.
          </motion.h1>

          <motion.p
            className="text-xl text-white border-t border-white/10 mb-10 pt-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            Analyze handwriting samples with the best graphologists.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="flex flex-col gap-4"
          >
            <div className="flex flex-wrap gap-4">
              {/* Get Started Button - blue only */}
              <Button
                primary
                to="/signup"
                className="px-6 py-3 flex items-center gap-2 rounded-full text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 transition-all duration-300 shadow-md"
              >
                Get started for free
                <img src={arrowCircleRight} alt="" className="w-5 h-5" />
              </Button>

              {/* Login Button */}
              <Button
                to="/login"
                className="px-6 py-3 rounded-full border border-blue/30 text-white/80 bg-transparent hover:bg-white/10 hover:text-white hover:border-blue/30 transition-all duration-300"
              >
                Login
              </Button>

              {/* Guest Button */}
              <button
                onClick={() => (window.location.href = '/forum')}
                className="px-6 py-3 rounded-full border border-white/30 text-white/80 bg-transparent hover:bg-white/10 hover:text-white hover:border-white/50 transition-all duration-300 text-sm"
              >
                Continue as guest
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
